import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/admin/sport')({
    component: SportLayout,
});

function SportLayout() {
    return <Outlet />;
}
